module.exports = __webpack_public_path__ + "img/405a8f5c5fe57b9c920d87a1331adaac.svg";